/*eslint-disable*/
import { firestore, deleteDoc, collection, getDocs, doc, updateDoc, where, getDoc, collectionGroup, setDoc, limit, orderBy, query, writeBatch, addDoc, onSnapshot,} from '../../utils/firestore'
import moment from 'moment'
import * as constants from '../../irmlib/src/common/constants'
import { getUser } from '../../redux/global'
import { getCache, addCache, getUserCountryCode } from './cache'
import { t } from 'i18n-js'
// import { publishImgData } from '../nats/localNatsTransactions'

const getTemplateTypesForWmsCacheMs = 60 * 60 * 1000

const GDE_TEMPLATES = 'gdeTemplates'
const BUILDINGS = 'buildings'
const LOCATIONS = 'locations'
const CONFIG = 'config'
const COUNTRIES = 'countries'
const WORKERS = 'workers'
const WORKERROLES = 'workerRoles'
const GDE_METRICS = 'gdeMetrics'
const GDE = 'gde'
const GDE_JOB_ACTIVITY = 'gdeActivities'
const GDE_JOB_SMART_CATALOG = 'scLocal'
const GDE_LOCAL_AI = 'scLocal'
const GDE_JOB_REQUEST = 'requests'
const GDE_SC_TEMPLATE = 'templates'
const GDE_SC_LOCKED_FIELD = 'lockedFields'
const GDE_JOB_IMAGES = 'images'
const GDE_SMART_CATALOG_ACTIVITIES = 'activities'
const SMART_QC_IMAGES = 'imagesQC'
const GDE_JOB_DASHBOARD = 'dashboard'
const GDE_JOB_DISTRICT = 'district'
const GDE_JOB_DISTRICTSTAT = 'districtStat'
const GDE_SMART_CATALOG_TRANSMITTALS = 'transmittals'
const smartCollections = {
  scLocalQCImg: 'gdeActivities/scLocal/imagesQC',
}
const EDGE_DEVICES_SUBCOLLECTION = 'edgeDevices'

export const getTemplateTypesForWms = async wms => {
  const key = 'getTemplateTypesForWms'
  let data = getCache(key, wms)
  if (data) {
    return data
  }
  const standTemplateQuery = query(collection(firestore, GDE_TEMPLATES), where('templateType', '==', 'STANDARD'), where('wmsCode', 'in', [wms]))
  data = await getDocs(standTemplateQuery)
  addCache(key, wms, data, getTemplateTypesForWmsCacheMs)
  return data
}

// this function is being used by View Local Quality Check to load the records  
export const getLocalQcFailedImagesListenerSnap = (val,setData,requiredImageFields)=>{
  const {workerId,district} = getUser()
  const { localQcDistrict,localQcBuilding } = val
  const conditions = []
  const extractRequiredField = (imgDataObj)=>{
    return requiredImageFields.reduce((acc, val) => {
      acc[val] = imgDataObj[val] 
      return acc;
    }, {})
  }
  conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_LOCAL_AI}`, SMART_QC_IMAGES)
  let index = 0
  if (
    localQcDistrict === constants.defaultSelect
  ) {
    conditions[++index] = where('district', '==', district)
  } else {
    if (localQcDistrict !== constants.defaultSelect) {
      conditions[++index] = where('district', '==', localQcDistrict)
      // where('district', 'in', val.districts)
    }
  }

  //check if there is any Building
  if(localQcBuilding && localQcBuilding?.trim() !== ''){
    conditions[++index] = where('building', '==', localQcBuilding)
  }

  //add filter fetech records only which are not locked
  conditions[++index] = where('isLocked', '==', false)
  const idleImagesQuery = query.apply(null, conditions)

  //now we need to create conditons arrray to fetech records assigned to  me if there is any
  conditions.pop()

  //now adding the codition ( workerId = mine  & isLocked = true & isQc or isProcessed = false)
  conditions.push(where('isLocked', '==', true))
  conditions.push(where('lockedBy', '==', workerId))
  conditions.push(where('isProcessed', '==', false))

  const assignedToMeQuery = query.apply(null, conditions)
  return new Promise((resolve,reject)=>{
  // for second snap
    const unsubscribeAssignedToMe = onSnapshot( assignedToMeQuery,
    (snapshot)=>{
      const docs = snapshot.docs.map(doc=>({documentID:doc.id,dataSource : 'assignedToMe', ...extractRequiredField(doc.data())}))
      if(docs){
           setData(prev=>{
          const existingIdlImagesRecords  = prev?.filter(record=>record.dataSource === "idlImages") || []
          return [...existingIdlImagesRecords,...docs]
        })
      }
    },
    (error)=>{
      reject(error)
    }
  )

      // for the first snap
  const unsubscribeIdlImages =   onSnapshot( idleImagesQuery,
    (snapshot)=>{
      const docs = snapshot.docs.map(doc=>({documentID:doc.id,dataSource : 'idlImages',...extractRequiredField( doc.data())}))
      if(docs){
        // eslint-disable-next-line no-undef
        setData(prev=>{
          const existingAsignToMeRecords  = prev?.filter(record=>record.dataSource === "assignedToMe") || []
          return [...existingAsignToMeRecords,...docs]
        })
      }
    },
    (error)=>{
      reject(error)
    }
  )

  resolve({unsubscribeAssignedToMe,unsubscribeIdlImages})

  }) 
}

export const getTemplatesForDeType = async (deType, wms) => {
  const templateQuery = query(collection(firestore, GDE_TEMPLATES), where('dataEntryType', '==', deType), where('wmsCode', '==', wms?.toUpperCase()))
  return getDocs(templateQuery)
}

export const getTemplates = async (deType, accLevel1 = '') => {
  const templateQuery = query(collection(firestore, GDE_TEMPLATES), where('dataEntryType', '==', deType), where('accountLevel1', '==', accLevel1?.toUpperCase()))
  return getDocs(templateQuery)
}

export const getWmsSystemFroCountry = async (countryCode) => {
  let data
  if (getUserCountryCode() === countryCode) {
    data = getCache(BUILDINGS, countryCode)
    if (data) {
      return data
    }
  }
  const buildingCollectionQuery = query(collectionGroup(firestore, BUILDINGS), where('countryCode', '==', countryCode))
  data = getDocs(buildingCollectionQuery)
  if (getUserCountryCode() === countryCode) {
    addCache(BUILDINGS, countryCode, data)
  }
  return data
}

export const getGdeConfig = async () => {
  const gdeConfig = await getDoc(doc(firestore, CONFIG, 'gde'))
  return [gdeConfig.data()?.lob, gdeConfig.data()?.assetTypes, gdeConfig.data()?.countrySettings, gdeConfig.data()?.templateType, gdeConfig.data()?.skpEncoding, gdeConfig.data()?.fileSequence, gdeConfig.data()?.fieldsSKP, gdeConfig.data()?.wmsConfig, gdeConfig.data()?.custEngmntType, gdeConfig.data()?.insideOutsideWorkflowList, gdeConfig.data()?.newWorkflow, gdeConfig.data()?.custExclusionType, gdeConfig.data()?.custExclusionReason]
}

export const getGdeConfigCountrySettings = async () => {
  const gdeConfig = await getDoc(doc(firestore, CONFIG, 'gde'))
  return [gdeConfig.data()?.countrySettings]
}

// export const getFederalCustomers = async (custId) => {
//   const fedCustConfig = await getDoc(doc(firestore, `${CONFIG}/gde/federalCustomers`, custId.toUpperCase()))
//   return fedCustConfig.exists()
// }

export const getFederalCustomers = async (accountLevel1, accountLevel2 = '', accountLevel3 = '') => {  // Helper function to check if document exists and isActive is true
  const normAccountLevel = (v) => {
    const s = v == null ? '' : String(v).trim()
    if (!s || s === constants.defaultSelect) return ''
    return s
  }

  const accLevel1 = normAccountLevel(accountLevel1)
  const accLevel2 = normAccountLevel(accountLevel2)
  const accLevel3 = normAccountLevel(accountLevel3)

  const checkDocument = async (docId) => {
    if (!docId) return false
    const fedCustConfig = await getDoc(doc(firestore, `${CONFIG}/gde/federalCustomers`, docId.toUpperCase()))
    if (fedCustConfig.exists()) {
      const data = fedCustConfig.data()
      return !!(data?.isActive && data?.isEdge)
    }
    return false
  }

  const checkParentAccountLevel1 = async (al1) => {
    const base = normAccountLevel(al1)
    if (!base) return false
    if (await checkDocument(base)) return true
    if (await checkDocument(`${base}||`)) return true
    if (await checkDocument(`${base}|`)) return true
    return false
  }

  if (accLevel1 !== '' && accLevel2 === '' && accLevel3 === '') {
    return await checkParentAccountLevel1(accLevel1)
  }

  if (accLevel1 !== '' && accLevel2 === '' && accLevel3 !== '') {
    const docIdL1L3 = `${accLevel1}||${accLevel3}`
    if (await checkDocument(docIdL1L3)) return true
    return await checkParentAccountLevel1(accLevel1)
  }

  if (accLevel1 !== '' && accLevel2 !== '' && accLevel3 === '') {
    const docIdd1 = `${accLevel1}|${accLevel2}|`
    if (await checkDocument(docIdd1)) return true
    return await checkParentAccountLevel1(accLevel1)
  }

  if (accLevel1 !== '' && accLevel2 !== '' && accLevel3 !== '') {
    const docId1 = `${accLevel1}|${accLevel2}|${accLevel3}`
    if (await checkDocument(docId1)) return true
    const docId2 = `${accLevel1}|${accLevel2}|`
    if (await checkDocument(docId2)) return true
    return await checkParentAccountLevel1(accLevel1)
  }
  return false
}

export const getLocationsForCountry = async (countryName) => {
  const locationsQuery = query(collection(firestore, LOCATIONS), where('country', '==', countryName))
  return getDocs(locationsQuery)
}

export const getCountryForDistrict = async (districtId) => {
  const districtInfo = await getDoc(doc(firestore, LOCATIONS, districtId))
  return districtInfo.data().country
}

export const getBuildingForDistrict = async (districtId) => {
  const districtInfo = await getDoc(doc(firestore, LOCATIONS, districtId))
  return districtInfo.data().buildings
}
export const getCstmrList = async (countryCode, custEngtype) => {
  const ENGTYPE = {
    'PROJECT':'Project',
  }
  const locationsQuery = query(collection(firestore, `${COUNTRIES}/${countryCode}/imtActivityGroup`), where('isActive', '==', true), where('activityGroup', '==', ENGTYPE[custEngtype]))
  return getDocs(locationsQuery)
}

export const getCountries = async () => {
  let data = getCache(COUNTRIES, COUNTRIES)
  if (data) {
    return data
  }
  data = getDocs(collection(firestore, COUNTRIES))
  addCache(COUNTRIES, COUNTRIES, data)
  return data
}

export const getCountrySkpInstance = async (countryName) => {
  const skpInstanceQuery = query(collection(firestore, COUNTRIES), where('countryName', '==', countryName))
  return getDocs(skpInstanceQuery)
}

export const getSkpInstance = async (countryCode) => {
  const skpInstanceQuery = await getDoc(doc(firestore, COUNTRIES, countryCode))
  return skpInstanceQuery.data()?.wms
}

export const getWorkerDetails = async (userId) => {
  const workerDetailsGde = await getGdeWorkerDetails(userId)
  const rawDataGde = workerDetailsGde.data()

  let data
  if (userId === getUser().workerId) {
    data = getCache(WORKERS, userId)
    if (data) {
      return data
    }
  }
  data = await getDoc(doc(firestore, WORKERS, userId))
  const rawData = data.data()

  if (rawDataGde?.gdeCountryCode !== undefined) {
    rawData.countryCode = rawDataGde.gdeCountryCode
    rawData.country = rawDataGde.gdeCountry
  }
  
  if (userId === getUser().workerId) {
    addCache(WORKERS, userId, rawData)
  }
  return rawData
}

export const getGdeWorkerDetails = async (userId) => {
  let gdeWorkerDetails
  if (userId === getUser().workerId) {
    gdeWorkerDetails = getCache(GDE, userId)
    if (gdeWorkerDetails) {
      return gdeWorkerDetails
    }
  }

  gdeWorkerDetails = getDoc(doc(firestore, WORKERS, userId, WORKERROLES, GDE))
  if (userId === getUser().workerId) {
    addCache(GDE, userId, gdeWorkerDetails)
  }
  return gdeWorkerDetails
}

export const getUserNameById = async (userId) => {
  try {
    const userDoc = await getDoc(doc(firestore, `${WORKERS}`, userId))
    if (userDoc.exists()) {
      const data = userDoc.data()
      const firstName = data.firstName || ''
      const lastName = data.lastName || ''
      return `${firstName} ${lastName}`
    } else {
      return 'user not found'
    }
  } catch (error) {
    console.error('Error fetching user data :', error)
    return 'Error fetching Data'
  }
}


export const getWorkers = async () => {
  return getDocs(collection(firestore, WORKERS))
}

export const getWorkersWithDistrict = async (district) => {
  let workersQuery
  if (typeof district === 'object') {
    workersQuery = query(collection(firestore, WORKERS), where('gdeDistrict', 'in', district))
  } else {
    workersQuery = query(collection(firestore, WORKERS), where('gdeDistrict', '==', district))
  }
  return getDocs(workersQuery)
}

export const getworkersLists = async (district) => {
  const workersDoc = []
  const rolesQuery = query(collectionGroup(firestore, 'workerRoles'), where('activityFamilyId', '==', 'gde'), where('district', 'array-contains', district))
  const workerRoleDoc = await getDocs(rolesQuery)
  workerRoleDoc.forEach(async (role) => {
    workersDoc.push(getDoc(doc(firestore, role.ref.parent.parent.path)))
  })
  const workers = await Promise.all(workersDoc)
  return workers
}

export const getCountryByID = async (countryId) => {
  return getDoc(doc(firestore, COUNTRIES, countryId))
}

export const getTemplateById = async (templateId) => {
  return getDoc(doc(firestore, GDE_TEMPLATES, templateId))
}

export const getTemplateById_SC = async (templateId) => {
  return getDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_TEMPLATE}`, templateId))
}

export const getGdeWorkerRole = async (userId) => {
  return firestore.collection(WORKERS).doc(userId).collection('workerRoles')
}

export const getGdeWorkerRoles = async (userId) => {
  const workerRolesQueryForDocs = query(collection(firestore, `${WORKERS}/${userId}/${WORKERROLES}`))
  return getDocs(workerRolesQueryForDocs)
}

export const getTransmittal = async (transmittalId) => {
  const transmittalDoc = await getDoc(doc(firestore, 
    `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`, 
    transmittalId)
  ) 
  const data = transmittalDoc.data()
  return data
}

export const fetchTransmittalsByBatchId = async (batchId) => {
  const q = query(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`), where('batchId', '==', batchId));
  const querySnapshot = await getDocs(q);
  const filteredData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  return filteredData;
}

export const listenTransmittalsByBatchId = (mode, batchId, setData) => {
  if (!batchId) return () => {}  // no-op unsubscribe if no batchId

  const q = query(
    collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`),
    where('batchId', '==', batchId)
  )
  if (mode === 'normal') {
    return getDocs(q)
  } else if (mode === 'listener') {
  const unsubscribe = onSnapshot(q, (snapshot) => {
    const filteredData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    setData(snapshot)
  }, (error) => {
    console.error('Listener error:', error)
  })
    return unsubscribe
  }

}

export const deleteTransmittal = async (transmittalId) => {
  return deleteDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`, transmittalId))
}

export const updateTransmittal = async (transmittalId, data) => {
  return updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`, transmittalId), data)
}

export const getTemplateFields = async (tempName) => {
  const templateQuery = query(doc(firestore, `${GDE_TEMPLATES}/${tempName}`))
  return getDoc(templateQuery)
}

export const getTemplateType = async () => {
  const templateType = query(collection(firestore, GDE_TEMPLATES))
  return getDocs(templateType)
}

export const getUserList = async (userIdArray) => {
  const userQuery = query(collection(firestore, WORKERS), where('workerId', 'in', userIdArray))
  return getDocs(userQuery)
}

export const getUsers = async (userIdArray) => {
  const userQuery = query(collection(firestore, WORKERS))
  return getDocs(userQuery)
}

export const getDistricts = async () => {
  const locationsQuery = query(collection(firestore, LOCATIONS))
  return getDocs(locationsQuery)
}

export const getDistrictsByCountry = async (countryName) => {
  const locationsQuery = query(collection(firestore, LOCATIONS), where('country', '==', countryName))
  return getDocs(locationsQuery)
}

export const getTemplateTypes = async (wms) => {
  const key = 'getTemplateTypes'
  let data = getCache(key, key)
  if (data) {
    return data
  }

  const standTemplateQuery = query(collection(firestore, GDE_TEMPLATES), where('templateType', '==', 'STANDARD'))
  data = getDocs(standTemplateQuery)
  addCache(key, key, data, getTemplateTypesForWmsCacheMs)
  return data
}

export const saveMetricsData = async (data) => {
  if (data.activityType === 'keystroke') {
    const workerLocation = getCache('wrokLocation', getUser()?.workerId)
    data.isMovedToBigQuery = false
    data.updatedTs = new Date()
    data.workerDistrict = workerLocation.district
    data.workerBuilding = workerLocation.building
  }
  return addDoc(collection(firestore, GDE_METRICS), data)
}

export const getWorkerRoleGde = async (workerId) => {
  const workerDetailsGde = await getDoc(doc(firestore, `workers/${workerId}/workerRoles/gde`))
  return workerDetailsGde.data()
}

export const createActivity = async (documentId, data) => {
  return setDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_REQUEST}`, documentId), data)
}

export const createSmartCatalogTemplate = async (documentId, data) => {
  return setDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_TEMPLATE}`, documentId), data)
}

export const createBoxTransmittals = async (documentId, data) => {
  return setDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`, documentId), data)
}

export const createSmartLockedFields = async (data) => {
  return addDoc(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_LOCKED_FIELD}`), data)
}

export const getLockedTemplateFields = async (customerId, lockField) => {
  const collectionRef = query(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_LOCKED_FIELD}`), where('customer', '==', customerId), where('templateField', '==', lockField))
  return await getDocs(collectionRef)
}
export const getLockedFieldsListner = async (customerId, lockField, setData, setDoc) => {
  const collectionRef = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_LOCKED_FIELD}`) 
  const querySnapshot = query(collectionRef, where('customer', '==', customerId))
  const unsubscribe = onSnapshot(querySnapshot, (snapshot) => {
    const updatedData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
    const lockedFieldData = updatedData.find(item => (item.customer === customerId && item.templateField === lockField))
    const docId = lockedFieldData?.id
    setDoc(docId)
    const lockedField = lockedFieldData?.[lockField] || []
    // const result = lockedGF.map(obj => ({ value: obj.value, workerId: obj.workerId }))
    setData(lockedField)
  })
  return unsubscribe
}

export const updateLocked = (documentId, selectedField, date, data) => {
  const exactPath = doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_LOCKED_FIELD}`, documentId)
  return updateDoc(exactPath, { [`${selectedField}`]: data, updatedTS: date })
}

export const getStandardTemplateName = (wmsInstance, templateType, assetType) => {
  let templateName = ''
  if (templateType === 'New') {
    templateName = `${wmsInstance.toLowerCase()}StandardNewFile`
    if (assetType === 'Single Box' || assetType === 'Multiple Boxes') {
      templateName = `${wmsInstance.toLowerCase()}StandardNewBox`
    } else if (assetType === 'Box Transmittal' ) {
      templateName = `${wmsInstance.toLowerCase()}StandardNewBoxTransmittal`
    }
  } else if (templateType === 'Maintenance') {
    templateName = `${wmsInstance.toLowerCase()}StandardMaintenanceFile`
    if (assetType === 'Single Box' || assetType === 'Multiple Boxes') {
      templateName = `${wmsInstance.toLowerCase()}StandardMaintenanceBox`
    } else if (assetType === 'Box Transmittal' ) {
      templateName = `${wmsInstance.toLowerCase()}StandardMaintenanceBoxTransmittal`
    }
  }
  return templateName
}

export const getRequests = async (formValues) => {
  const conditions = []
  const templateType = formValues?.templateType
  const assetType = formValues?.assetType
  const wmsInstance = formValues?.wmsInstance
  const accountLevel1 = formValues?.accountLevel1
  const accountLevel2 = formValues?.accountLevel2
  const accountLevel3 = formValues?.accountLevel3
  conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SC_TEMPLATE)
  let index = 0
  conditions[++index] = where('isActive', '==', true)
  if (accountLevel1 !== '') {
    conditions[++index] = where('accountLevel1', '==', accountLevel1.toUpperCase())
  }
  if (accountLevel2 && accountLevel2 !== '') {
    conditions[++index] = where('accountLevel2', '==', accountLevel2.toUpperCase())
  }
  if (accountLevel3 && accountLevel3 !== '') {
    conditions[++index] = where('accountLevel3', '==', accountLevel3.toUpperCase())
  }

  if (wmsInstance !== '' && wmsInstance !== undefined) {
    const templateName = getStandardTemplateName(wmsInstance, templateType, assetType)
    conditions[++index] = where('templateName', '==', templateName)
  } else {
    if (assetType && assetType !== constants.defaultSelect && assetType !== '') {
      conditions[++index] = where('assetType', '==', formValues.assetType)
    }
    if (templateType && templateType !== constants.defaultSelect && templateType !== '') {
      conditions[++index] = where('templateType', '==', templateType)
    }
  }
  const standTemplateQuery = query.apply(null, conditions)
  return await getDocs(standTemplateQuery)
}

export const getGlobalTransmittalTemplates = async (selectedWmsInstance, accountLevelone, templateTypeSelected) => {
  const conditions = []
  const templateType = templateTypeSelected
  const assetType = 'Box Transmittal'
  const wmsInstance = selectedWmsInstance
  const accountLevel1 = accountLevelone
  if (wmsInstance !== '' && wmsInstance !== undefined && wmsInstance !== t('demo.noText')) {
    conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SC_TEMPLATE)
    let index = 0

    conditions[++index] = where('isActive', '==', true)
    if (accountLevel1 !== '') {
      conditions[++index] = where('accountLevel1', 'in', ['GLOBALTEMPLATE', accountLevel1.toUpperCase()])
    }

    if (wmsInstance !== '') {
      conditions[++index] = where('wmsCode', '==', wmsInstance.toUpperCase())
    }
    const templateName = getStandardTemplateName(wmsInstance, templateType, assetType)
    conditions[++index] = where('templateName', '==', templateName)
    const standTemplateQuery = query.apply(null, conditions)
    return await getDocs(standTemplateQuery)
  }
}

export const updateSmartCatalogTemplate = async (templateId, data) => {
  await updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SC_TEMPLATE, templateId), data)
  return true
}

export const saveActivityImages = async (data) => {
  const result = await addDoc(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`), data)
  return result.id
}

export const edgeAISaveActivityImages = async (data) => {
  const result = await addDoc(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_LOCAL_AI}/${GDE_JOB_IMAGES}`), data)
  return result.id
}

export const updateActivityData = async (activityId, data) => {
  await updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_ACTIVITIES}`, activityId), data)
}

export const getActivityByID = async (activityId) => {
  const workerDetailsGde = await getDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_ACTIVITIES}`, activityId))
  return workerDetailsGde.data()
}

export const createClonedActivity = async (data) => {
  return addDoc(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_ACTIVITIES}`), data)
}

export const getImagesAndUpdate = async (activityId, data, initialStatus, publishNatsImgData) => {
  const imagesSnapshot = query(
    collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`), 
    where('activityId', '==', activityId),
    where('isActive', '==', true) // Uncomment after testing
  )

  const images = await getDocs(imagesSnapshot)
  const imagesDocs = images.docs

  const BATCH_SIZE = 10 
  for (let i = 0; i < imagesDocs.length; i += BATCH_SIZE) {
    const batch = imagesDocs.slice(i, i + BATCH_SIZE).map(async (image) => {
      const imageData = {
        ...image.data(),
        ...data,
        isPublished: true,
        isProcessed: false,
        publishedAt: (new Date()).toISOString()
      }
      if (typeof publishNatsImgData !== 'function') {
        throw new Error('getImagesAndUpdate requires a publishFn callback')
      }
      const { publishedData, msgId } = await publishNatsImgData(constants.LOCAL_NATS_SERVER, imageData)
      // const { publishedData, msgId } = await publishImgData(constants.LOCAL_NATS_SERVER, imageData)
      return updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`, image.id), {...imageData, messageId: msgId})
    })

    await Promise.all(batch)
  }

  const activityDataToUpdate = {
    status: initialStatus || constants.activityStatus.completed,
    updatedTS: (new Date()).toISOString(),
    imgFailCount: 0,
    imgProcessCount: 0,
    isIdpFail: false,
  }
  await updateActivityData(activityId, activityDataToUpdate)
}

export const updateQCImgDoc = async (imageDocId, data, imgID, imgData) => {
  if (imgID) {
    const imagesQC = await updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${SMART_QC_IMAGES}`, imageDocId), data)
    const images = await updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`, imgID), imgData)
    return { imagesQC, images }
  } else {
    return await updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${SMART_QC_IMAGES}`, imageDocId), data)
  }
}

// export const updateQCImgData = async (imageDocId, templateId, imgResponse) => {
//   const querySnapshot = query(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_TEMPLATE}`), where('templateId', '==', templateId))
//   const snapshot = await getDocs(querySnapshot)
//   const updatedData = snapshot.docs.map(doc => ({
//     id: doc.id,
//     ...doc.data()
//   }))
//   const data = {
//     imgResponse: imgResponse,
//     template: updatedData[0]?.template || {},
//     templateLocked: updatedData[0]?.templateLocked || {}
//   }
//   return await updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${SMART_QC_IMAGES}`, imageDocId), data)
// }

export const imagesListner = async (setData, activityId) => {
  const collectionRef = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`)
  const querySnapshot = query(collectionRef, where('activityId', '==', activityId), orderBy('createdTS', 'asc'))
  const unsubscribe = onSnapshot(querySnapshot, (snapshot) => {
    const updatedData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
    setData(updatedData)
  })
  return unsubscribe
}

export const statusListner = async (setData, requestId) => {
  const collectionRef = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`)
  const querySnapshot = query(collectionRef, where('requestId', '==', requestId))
  const unsubscribe = onSnapshot(querySnapshot, (snapshot) => {
    const updatedData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
    setData(updatedData)
  })
  return unsubscribe
}

export const updateImage = async (id, data) => {
  await updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`, id), data)
}

const imageHasRepublishableError = (imageData) => {
  return imageData?.status === 'IDP Failure' ||
    imageData?.status === 'HITL Reject'
}

export const updateFailedBoxStatusAfterImageRepublish = async (activityId, imageId) => {
  let targetActivityId = activityId

  if (!targetActivityId && imageId) {
    const imageDoc = await getDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`, imageId))
    targetActivityId = imageDoc.data()?.activityId
  }

  if (!targetActivityId) {
    return false
  }

  const activityRef = doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_ACTIVITIES}`, targetActivityId)
  const activityDoc = await getDoc(activityRef)
  const activityData = activityDoc.data()

  if (activityData?.status !== constants.activityStatus.failed) {
    return false
  }

  const imagesQuery = query(
    collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`),
    where('activityId', '==', targetActivityId)
  )
  const images = await getDocs(imagesQuery)
  const errorImages = images.docs
    .map(doc => doc.data())
    .filter(imageData => imageData?.isActive === true || imageData?.isActive === undefined)
    .filter(imageHasRepublishableError)

  if (errorImages.length > 0) {
    return false
  }

  await updateDoc(activityRef, {
    status: constants.activityStatus.completed,
    updateTS: (new Date()).toISOString(),
    imgFailCount: 0,
    isIdpFail: false,
  })

  return true
}

export const countListner = async (setData, requestId) => {
  const collectionRef = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_REQUEST}`)
  const querySnapshot = query(collectionRef, where('requestId', '==', requestId))
  const unsubscribe = onSnapshot(querySnapshot, (snapshot) => {
    const updatedData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
    setData(updatedData)
  })
  return unsubscribe
}

export const boxesListener = async (setData, requestId) => {
  const collectionRef = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_ACTIVITIES}`)
  const querySnapshot = query(collectionRef, where('requestId', '==', requestId))
  const unsubscribe = onSnapshot(querySnapshot, (snapshot) => {
    const updatedData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
    setData(updatedData)
  })
  return unsubscribe
}

export const updateRequestData = async (requestId, data) => {
  await updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_REQUEST}`, requestId), data)
}

export const getGdeActivity = async (mode, val, selected, setData) => {
  const userval = getUser()
  const loggedInUserDistrict = selected ? selected : userval.district
  const conditions = []
  conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_JOB_REQUEST)
  let index = 0
  if (
    val.status === constants.defaultSelect &&
    val.districts[0] === constants.defaultSelect
  ) {
    conditions[++index] = where('status', 'in', ['pending', 'In Progress'])
    conditions[++index] = where('district', '==', loggedInUserDistrict)
  } else {
    if (val.status !== constants.defaultSelect) {
      if (Array.isArray(val.status)) {
        conditions[++index] = where('status', 'in', val.status)
      } else {
        conditions[++index] = where('status', '==', val.status)
      }
      if (val.districts[0] === constants.defaultSelect) {
        conditions[++index] = where('district', '==', loggedInUserDistrict)
      }
    }
    if (val.districts[0] !== constants.defaultSelect) {
      conditions[++index] = where('district', 'in', val.districts)
      if (val.status === constants.defaultSelect) {
        conditions[++index] = where('status', 'in', ['pending', 'In Progress'])
      }
    }
  }

  const standTemplateQuery = query.apply(null, conditions)
  if (mode === 'normal') {
    return await getDocs(standTemplateQuery)
  } else if (mode === 'listener') {
    const unsubscribe = onSnapshot(standTemplateQuery, (snapshot) => {
      setData(snapshot)
    })
    return unsubscribe
  }
}

export const getrequestIdbydistandStatus = async (district, building, statuses) => {
  
  const results = await Promise.all(
    statuses.map(async (status) => {
      const statusKey = status;
      if (!statusKey) return { status, Filtereddocs: [], count: 0 };
      const conditions = []
      conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`)
      let index = 0
      if (district && district !== '') {
        conditions[++index] = where('district', '==', district)
      }
      if (building && building !== '') {
        conditions[++index] = where('building', '==', building)
      }
      if (statusKey && statusKey !== '') {
        conditions[++index] = where('status', '==', statusKey)
      }
      const standTemplateQuery = query.apply(null, conditions)  
      const querySnapshot = await getDocs(standTemplateQuery);

      return {
        status,
        Filtereddocs: querySnapshot.docs.map((doc) => doc.data()),
        count: querySnapshot.docs.length,
      };
    })
  ).catch((error) => {
    console.error('Error fetching data from Firestore:', error);
    throw error;
  });

  return results.reduce((acc, { status, Filtereddocs, count }) => {
    acc[status] = { count, Filtereddocs};
    return acc;
  }, {});
};
export const getImagesByDistrictandFormat = async (district, building) => {
  const conditions = []
  conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_JOB_IMAGES)
  let index = 0
  conditions[++index] = where('formatError', '==', true )
   if (district && district !== '') {
    conditions[++index] = where('district', '==', district)
  }
  if (building && building !== '') {
    conditions[++index] = where('building', '==', building)
  }
  const standTemplateQuery = query.apply(null, conditions)  
  const querySnapshot = await getDocs(standTemplateQuery);
  const images = querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  }));

  return images;
};

export const getImagesByDistrictandFormatListener = async (setData, district, building) => {
  const conditions = []
  conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_JOB_IMAGES)
  let index = 0
  conditions[++index] = where('formatError', '==', true )
   if (district && district !== '') {
    conditions[++index] = where('district', '==', district)
  }
  if (building && building !== '') {
    conditions[++index] = where('building', '==', building)
  }
  const standTemplateQuery = query.apply(null, conditions)  
  
  const unsubscribe = onSnapshot(standTemplateQuery, (snapshot) => {
      const data = snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  }))
  setData(data)
    })
    return unsubscribe
};

export const getRequestIdByDistAndStatusListener = (setData, district, building, statuses) => {
  const unsubscribeFunctions = [];

  statuses.forEach((status) => {
    if (!status) return;
    const conditions = []
    conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`)
    let index = 0
    if (district && district !== '') {
      conditions[++index] = where('district', '==', district)
    }
    if (building && building !== '') {
      conditions[++index] = where('building', '==', building)
    }
    if (status && status !== '') {
      conditions[++index] = where('status', '==', status)
    }
    const statusQuery = query.apply(null, conditions)
    const unsubscribe = onSnapshot(statusQuery, (snapshot) => {
      const filteredDocs = snapshot.docs.map((doc) => doc.data());
      
      const data = {
        status,
        Filtereddocs: filteredDocs,
        count: filteredDocs.length,
      };
      setData((prevState) => ({
        ...prevState,
        [status]: data,
      }));
    });

    unsubscribeFunctions.push(unsubscribe);
  });

  return () => unsubscribeFunctions.forEach((unsubscribe) => unsubscribe());
}

export const getCustomRequestNameById = async (requestId) => {
  const boxQuery = await getDoc(doc(firestore, 
    `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_REQUEST}`, 
    requestId)
  ) 
  // Return only the customRequestName from the document data
  return boxQuery.data()?.customRequestName 
}

export const getRequest = async (selectedDistrict) => {
  try {
    const userval = getUser()
    const userSelectedDistricts = (!selectedDistrict || selectedDistrict.length === 0) ? userval.district : selectedDistrict

    const standTemplateQuery = await getDoc(doc(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_DASHBOARD}/${GDE_JOB_DISTRICT}/${GDE_JOB_DISTRICTSTAT}`), userSelectedDistricts))
    
    if (!standTemplateQuery.exists()) {
      console.error('Document does not exist')
      return null
    }

    const allDocs = standTemplateQuery.data().Data
    return allDocs

  } catch (error) {
    console.error('Error fetching request data:', error)
    return null
  }
}

export const getRequestsByDistrict = async(district, building) => {
  try {
    const conditions = []
    conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_JOB_REQUEST)
    let index = 0
    if (district && district !== '') {
      conditions[++index] = where('district', '==', district)
    }
    if (building && building !== '') {
      conditions[++index] = where('building', '==', building)
    }
    const standTemplateQuery = query.apply(null, conditions)
    return await getDocs(standTemplateQuery)
  } catch (error) {
    console.log('Error fetching requests by district data', error)
  }
}

export const getBoxTransmittalByDist = async (district, building) => {
  try {
    const conditions = []
    conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SMART_CATALOG_TRANSMITTALS)
    let index = 0
    if (district && district !== '') {
      conditions[++index] = where('district', '==', district)
    }
    if (building && building !== '') {
      conditions[++index] = where('building', '==', building)
    }
    const standTemplateQuery = query.apply(null, conditions)
    return await getDocs(standTemplateQuery)
  } catch (error) {
    console.log('Error fetching requests by district data', error)
  }
}

export const getCustomerID = async () => {
  const boxQuery = query(
    collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_TEMPLATE}`)
  )
  return getDocs(boxQuery)
}

export const getTemplatesListener = async (formValues, mode, setData) => {
  const conditions = []
  const templateType = formValues?.templateType
  const assetType = formValues?.assetType
  const wmsInstance = formValues?.wmsInstance
  const accountLevel1 = formValues?.accountLevel1
  const accountLevel2 = formValues?.accountLevel2
  const accountLevel3 = formValues?.accountLevel3
  conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SC_TEMPLATE)
  let index = 0
  conditions[++index] = where('isActive', '==', true)
  if (accountLevel1 !== '') {
    conditions[++index] = where('accountLevel1', '==', accountLevel1.toUpperCase())
  }
  if (accountLevel2 !== '') {
    conditions[++index] = where('accountLevel2', '==', accountLevel2.toUpperCase())
  }
  if (accountLevel3 !== '') {
    conditions[++index] = where('accountLevel3', '==', accountLevel3.toUpperCase())
  }

  if (wmsInstance !== '' && wmsInstance !== undefined) {
    const templateName = getStandardTemplateName(wmsInstance, templateType, assetType)
    conditions[++index] = where('templateName', '==', templateName)
  }
  if (assetType && assetType !== constants.defaultSelect && assetType !== '') {
    conditions[++index] = where('assetType', '==', assetType)
  }
  if (templateType && templateType !== constants.defaultSelect && templateType !== '') {
    conditions[++index] = where('templateType', '==', templateType)
  
  }
  const standTemplateQuery = query.apply(null, conditions)

  if (mode === 'normal') {
    return await getDocs(standTemplateQuery)
  } else if (mode === 'listener') {
    const unsubscribe = onSnapshot(standTemplateQuery, (snapshot) => {
      setData(snapshot)
    })
    return unsubscribe
  }
}

// 1227: Response Details for each box which are published and Processed
export const getSelectedResponse = async (activityId, total) => {
  let collectionImg
  if (total) {
    collectionImg = query(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`), where('requestId', '==', activityId))
  } else {
    collectionImg = query(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`), where('activityId', '==', activityId), orderBy('createdTS', 'asc'))
  }
  const imageSnapshot = await getDocs(collectionImg)
  const imageData = imageSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }))
  return imageData
}

// 1330: ResponseDetails for Transmittals
export const getSelectedFormat = async (transmittalId) => {
  const collectionData = query(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`), where('id', '==', transmittalId))
  const transmittalSnapshot = await getDocs(collectionData)
  const transmittalData = transmittalSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }))
  return transmittalData
}
export const getImagesFormat = async (imageID) => {
  const collectionData = query(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`), where('id', '==', imageID))
  const imageSnapshot = await getDocs(collectionData)
  const imageData = imageSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }))
  return imageData
}

export const getQcImgData = async (imageDocID) => {
  const collectionData = await getDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${SMART_QC_IMAGES}`, imageDocID))
  return collectionData.data()
}

export const getCustomerIdForBoxTrans = async () => {
  const boxQuery = query(
    collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`)
  )
  return getDocs(boxQuery)
}

export const getBoxTransmittalsExcepDetail = async (exceptionType, district, building) => {
  const conditions = []
  conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SMART_CATALOG_TRANSMITTALS)
  let index = 0
  if (district && district !== '') {
    conditions[++index] = where('district', '==', district)
  }
  if (building && building !== '') {
    conditions[++index] = where('building', '==', building)
  }
  if(exceptionType === 'format')
    conditions[++index] = where('formatError', '==', true)
  if(exceptionType === 'failed')
    conditions[++index] = where('status', '==', 'failed')

  const standTemplateQuery = query.apply(null, conditions)
  return await getDocs(standTemplateQuery)
  
}

export const getBoxTransmittalsListener = async (mode, val, setData) => {
  const userval = getUser()
  const loggedInUserDistrict = userval.district
  const conditions = []
  conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SMART_CATALOG_TRANSMITTALS)
  let index = 0

  // conditions[++index] = where('isActive', '==', true)
  if (
    val.status === constants.defaultSelect &&
    val.districts[0] === constants.defaultSelect
  ) {
    conditions[++index] = where('status', 'in', ['pending', 'published'])
    conditions[++index] = where('district', '==', loggedInUserDistrict)
  } else {
    if (val.status !== constants.defaultSelect) {
      if (Array.isArray(val.status)) {
        conditions[++index] = where('status', 'in', val.status)
      } else {
        conditions[++index] = where('status', '==', val.status)
      }
      if (val.districts[0] === constants.defaultSelect) {
        conditions[++index] = where('district', '==', loggedInUserDistrict)
      }
    }
    if (val.districts[0] !== constants.defaultSelect) {
      conditions[++index] = where('district', 'in', val.districts)
      if (val.status === constants.defaultSelect) {
        conditions[++index] = where('status', 'in', ['pending', 'published'])
      }
    }
  }

  const standTemplateQuery = query.apply(null, conditions)

  if (mode === 'normal') {
    return await getDocs(standTemplateQuery)
  } else if (mode === 'listener') {
    const unsubscribe = onSnapshot(standTemplateQuery, (snapshot) => {
      setData(snapshot)
    })
    return unsubscribe
  }
}

/*  
fuction to handle when user click on imageId for viewQualityCheckPage 
1) check if document exsit field already locked
2) update - asign image to user ad lock the field
3) transaction ends
*/

export const lockAndAsignQualityCheckImagesToUser = async (docId) => {
  if (!docId) {
    throw new Error('Error while fetching the doc')
  }
  const { workerId } = getUser()
  const docRef = doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_LOCAL_AI}/${SMART_QC_IMAGES}`, docId)
  await firestore.runTransaction(async (tranaction) => {
    const docSnap = await tranaction.get(docRef)
    // first check if doc exist and field is already locked
    if (!docSnap.exists) {
      throw new Error('Error while fetching the doc')
    }
    const data = docSnap.data()
    if (data.isLocked) {
      // check if field is locked, Qc is not completed and it is assigned to user already 
      if (data.isLocked && !data.isQC && data.lockedBy === workerId) {
        return true;
      } else {
        throw new Error('Locked Image Error')
      }
    }
    // update :: field is not locked assign the document to user and lock the record
    tranaction.update(docRef, { 'isLocked': true, 'lockedBy': workerId })
  })
}

//get firebase docId from imgId
export const getDocIdforImg = async (imgId) => {
  const q = query(
    collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_LOCAL_AI}/${SMART_QC_IMAGES}`),
    where("imgId", "==", imgId)
  )
  const snapp = await getDocs(q)
    if (snapp.empty) return { status: "not-found" }

  const docId = snapp.docs[0].id
  return docId
}

// lock image for the user when user navigates to that image
export const tryLockImage = async (imgId) => {
  const { workerId } = getUser();
  // STEP 1: Query to find document by imgId
  const q = query(
    collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_LOCAL_AI}/${SMART_QC_IMAGES}`),
    where("imgId", "==", imgId)
  )
  const snapp = await getDocs(q)
    if (snapp.empty) return { status: "not-found" }

    // STEP 2: Extract document ref
  const docRef = snapp.docs[0].ref


  return await firestore.runTransaction(async (tx) => {
    const snap = await tx.get(docRef);
    if (!snap.exists) return { status: "not-found" };

    const data = snap.data();

    // If qc is completed, don't unlock
    if (data.isQC) {
      return { status: "qc-complete" };
    }

    // If locked by someone else → block
    if (data.isLocked && data.lockedBy !== workerId) {
      return { status: "locked-other", lockedBy: data.workerId };
    }

    // If unlocked → lock it
    if (!data.isLocked) {
      tx.update(docRef, { isLocked: true, lockedBy: workerId });
      return { status: "locked-now" };
    }

    // If locked but by same user → just allow
    if (data.lockedBy === workerId && !data.isQC) {
      return { status: "already-locked-you" };
    }
  });
}

// unlock image if qc is not complete and user clicks on prev button
export const unlockIfQCNotCompleted = async (imgId) => {
  const { workerId } = getUser()

  // STEP 1: Query to find document by imgId
  const q = query(
    collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_LOCAL_AI}/${SMART_QC_IMAGES}`),
    where("imgId", "==", imgId)
  )
  const snapp = await getDocs(q)
    if (snapp.empty) return { status: "not-found" }

    // STEP 2: Extract document ref
  const ref = snapp.docs[0].ref

  await firestore.runTransaction(async (tx) => {
    const snap = await tx.get(ref)
    if (!snap.exists) return

    const data = snap.data()

    // If QC already done → DO NOT unlock
    if (data.isQC) {
      return
    }

    // If the image is locked by another user → DO NOT unlock
    if (data.lockedBy && data.lockedBy !== workerId) {
      return
    }

    // If QC not completed AND locked by same user → unlock it
    tx.update(ref, {
      isLocked: false,
      lockedBy: null,
    })

  })
}

// get image Data
export const getImageData = async (id) => {
  const imageData = await getDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`, id))
  return imageData.data()
}

//edge ai - configuration - country settings
export const getCountrySettingsListener = (mode, setData) => {
  const docRef = doc(firestore, CONFIG, 'gde')

  if (mode === 'normal') {
    // One-time fetch
    return getDoc(docRef).then((snapshot) => {
      const data = snapshot.data()?.countrySettings || {}
      setData(data)
      return data
    })
  } else if (mode === 'listener') {
    // Real-time listener
    const unsubscribe = onSnapshot(docRef, (snapshot) => {
      const rawData = snapshot.data()?.countrySettings || {}
      const dataArray = Object.values(rawData)
      setData(dataArray)
    }, (error) => {
      console.error("Listener failed:", error)
    })
    
    return unsubscribe
  }
}

export const saveCountrySetting = async (payload) => {
  // Reference the specific document shown in your image_fbbbc4.png
  const docRef = doc(firestore, 'config', 'gde');
  const key = payload.countryCode

  try {
    // merge: true ensures you only add/update this specific country key
    await setDoc(docRef, {
      countrySettings: {
        [key]: {
          ...payload,
          updatedAt: new Date()
        }
      }
    }, { merge: true })

    return { success: true }
  } catch (e) {
    console.error("Error updating countrySettings map: ", e)
    throw e
  }
}

// Edge Device Management - gde/config/edgeDevices collection
export const getEdgeDevicesListener = (mode, setData) => {
  const collectionRef = collection(firestore, `${CONFIG}/gde/edgeDevices`)
  if (mode === 'normal') {
    return getDocs(collectionRef)
  } else if (mode === 'listener') {
    const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
      setData(snapshot)
    })
    return unsubscribe
  }
}

const getDistrictIdsFromAssignedDistricts = (assignedDistricts) => {
  if (!assignedDistricts) return []
  if (Array.isArray(assignedDistricts)) return assignedDistricts.map(String)
  if (typeof assignedDistricts === 'object') return Object.keys(assignedDistricts).map(String)
  return []
}

const getBuildingIdsFromDistrict = (buildings) => {
  if (!buildings) return []
  if (Array.isArray(buildings)) return buildings.map(String)
  if (typeof buildings === 'object') return Object.keys(buildings).map(String)
  return []
}

const getBuildingIdsForDistrict = async (districtId) => {
  const districtRef = doc(firestore, LOCATIONS, districtId)
  const districtSnap = await getDoc(districtRef)
  if (!districtSnap.exists()) return []

  const data = districtSnap.data()
  const fromField = getBuildingIdsFromDistrict(data?.buildings)
  if (fromField.length > 0) return fromField

  const buildingsColRef = collection(firestore, LOCATIONS, districtId, BUILDINGS)
  const buildingsSnap = await getDocs(buildingsColRef)
  if (buildingsSnap.empty) {
    return [districtId]
  }
  return buildingsSnap.docs.map((d) => d.id)
}

const writeEdgeDeviceToLocationBuildings = async (deviceId, deviceData) => {
  const districtIds = getDistrictIdsFromAssignedDistricts(deviceData.assignedDistricts)
  if (districtIds.length === 0) return
  const BATCH_SIZE = 500
  let batch = writeBatch(firestore)
  let count = 0
  const payload = { ...deviceData, id: deviceId }
  for (const districtId of districtIds) {
    const locationRef = doc(firestore, LOCATIONS, districtId)
    batch.set(locationRef, { edgeEnabled: true }, { merge: true })
    count += 1
    if (count >= BATCH_SIZE) {
      await batch.commit()
      batch = writeBatch(firestore)
      count = 0
    }
    const buildingIds = await getBuildingIdsForDistrict(districtId)
    for (const buildingId of buildingIds) {
      const edgeDevicesRef = doc(collection(firestore, LOCATIONS, districtId, BUILDINGS, buildingId, EDGE_DEVICES_SUBCOLLECTION), deviceId)
      batch.set(edgeDevicesRef, payload)
      count += 1
      if (count >= BATCH_SIZE) {
        await batch.commit()
        batch = writeBatch(firestore)
        count = 0
      }
    }
  }
  if (count > 0) await batch.commit()
}

export const createEdgeDevice = async (data) => {
  const collectionRef = collection(firestore, `${CONFIG}/gde/edgeDevices`)
  const docRef = await addDoc(collectionRef, data)
  const deviceId = docRef.id
  try {
    await writeEdgeDeviceToLocationBuildings(deviceId, data)
  } catch (err) {
    console.error('createEdgeDevice: failed to write to locations/buildings/edgeDevices', err)
  }
  return deviceId
}

export const updateEdgeDevice = async (documentId, data) => {
  const exactPath = doc(firestore, `${CONFIG}/gde/edgeDevices`, documentId)
  try {
    await writeEdgeDeviceToLocationBuildings(documentId, { ...data, id: documentId })
  } catch (err) {
    console.error('updateEdgeDevice: failed to sync locations/buildings/edgeDevices', err)
  }
  return updateDoc(exactPath, data)
}

// to fetch the connection string

export const getLocalServerUrl = async ()=>{
  try{
    let { district } = getUser()
    let operationalBuilding = []
    // if there no building on dasboard this condition will be required in future if we fetech building dynamically
    if(!operationalBuilding || !operationalBuilding?.[0]){

      const buildingCollectionRef = collection(firestore, LOCATIONS, district, BUILDINGS)
      const buildingSnapshot = await getDocs(buildingCollectionRef)
      const buildingData = buildingSnapshot?.docs?.map(snap=>{
        return snap.id
        // return{
        //   id : snap.id,
        //   ...snap.data()
        // }
      })
      operationalBuilding = buildingData
    }
    const docRef = doc(firestore, LOCATIONS, district) 
    const fetchedDoc = await getDoc(docRef)
    if(!fetchedDoc.exists()) throw new Error('device address not found please contact Admin')

    const locationInfo = fetchedDoc.data()
    
    // check if edgeAI device is enabled
    if(!locationInfo.edgeEnabled) throw new Error('device address not found please contact Admin')
    // /locations/A-ATLANTA/buildings/A SH
    const buildingRef = collection(firestore, LOCATIONS, district, BUILDINGS, `${operationalBuilding[0]}/${EDGE_DEVICES_SUBCOLLECTION}`)
    const edgeDevicesSnapshot = await getDocs(buildingRef)
    const edgeDevicesData = edgeDevicesSnapshot?.docs?.map(snap=>{
      return{
        id : snap.id,
        ...snap.data()
      }
    })
    //check if there is no device
    if(edgeDevicesData.length < 0) return null

    const {deviceIP, devicePort} = edgeDevicesData[0]
    // example url :- 'ws://127.0.0.1:8080'
    const localAiServerURL =  new URL(`${constants.LOCAL_AI_PROTOCAL}://${deviceIP}:${devicePort}`)
    // check for null value
    if(!localAiServerURL){
      throw new Error('device address not found please contact Admin')
   }

   return localAiServerURL
  }catch(err){
      const customError = new Error('device address not found please contact Admin')
      customError.status = constants.CUSOTM_LOCAL_AI_ERROR_CODES.CONNECTION_STRING_NOT_FOUND
      throw customError
  }
}

